import { PREREGISTRATION_DASHBOARD_ENDPOINT, PREREGISTRATION_DASHBOARD_REFRESH_ENDPOINT, PREREGISTRATION_DASHBOARD_SCHOOL_ENDPOINT, PREREGISTRATION_DASHBOARD_SCHOOL_REFRESH_ENDPOINT, SCHOOL_SETTINGS_ENDPOINT} from "@constants/Endpoints";
import { apiCallJson } from "@helpers/ApiCall";

/**
 * @async
 * @returns {Promise<Object>} A promise that resolves to the pre-registration status of the school.
 */
export async function getDashboardPreregistrationAllStats() {
    return await apiCallJson(`${PREREGISTRATION_DASHBOARD_ENDPOINT}`, "GET", null);
}
/**
 * @async
 * @param {string} schoolId - The unique identifier of the school.
 * @returns {Promise<Object>} A promise that resolves to the pre-registration status of the school.
 */
export async function getDashboardPreregistrationBySchool(schoolId) {
     return await apiCallJson(`${PREREGISTRATION_DASHBOARD_SCHOOL_ENDPOINT}?schoolId=${schoolId}`, "GET", null);
}

/**
 * @async
 * @returns {Promise<Object>} A promise that resolves to the pre-registration status of the school.
 */
export async function getDashboardPreregistrationRefreshAll() {
    return await apiCallJson(`${PREREGISTRATION_DASHBOARD_REFRESH_ENDPOINT}`, "GET", null);
}
/**
 * @async
 * @param {string} schoolId - The unique identifier of the school.
 * @returns {Promise<Object>} A promise that resolves to the pre-registration status of the school.
 */
export async function getDashboardPreregistrationRefreshBySchool(schoolId) {
    return await apiCallJson(`${PREREGISTRATION_DASHBOARD_SCHOOL_REFRESH_ENDPOINT}?schoolId=${schoolId}`, "GET", null);
}
/**
 * @async
 * @param {string} schoolId - The unique identifier of the school.
 * @returns {Promise<Object>} A promise that resolves to the pre-registration status of the school.
 */
export async function getSchoolSettings(schoolId) {
    return await apiCallJson(`${SCHOOL_SETTINGS_ENDPOINT}?schoolId=${schoolId}`, "GET", null);
}